var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_52_3473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2 3.9C8.76482 3.64045 9.37841 3.5041 10 3.5C11.1935 3.5 12.3381 3.97411 13.182 4.81802C14.0259 5.66193 14.5 6.80653 14.5 8C14.4988 8.53004 14.4005 9.05538 14.21 9.55L17 12.14C18.2456 10.9558 19.2626 9.55245 20 8C20 8 17 1 10 1C8.62119 0.993706 7.25711 1.28357 6 1.85L8.2 3.9ZM2 0L1 1L3.55 3.4C2.0556 4.66591 0.845796 6.23354 0 8C0 8 3 15 10 15C11.6194 15.008 13.2149 14.6091 14.64 13.84L18 17L19 16L2 0ZM10 12.5C8.80653 12.5 7.66193 12.0259 6.81802 11.182C5.97411 10.3381 5.5 9.19347 5.5 8C5.50552 7.227 5.71231 6.46877 6.1 5.8L7.63 7.24C7.54715 7.48497 7.50328 7.74142 7.5 8C7.49899 8.407 7.59776 8.80805 7.78767 9.16804C7.97758 9.52802 8.25284 9.83596 8.58934 10.0649C8.92585 10.2939 9.31335 10.4368 9.71792 10.4813C10.1225 10.5258 10.5318 10.4704 10.91 10.32L12.45 11.77C11.7218 12.2467 10.8703 12.5004 10 12.5Z",
    fill: "url(#paint0_linear_52_3473)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_52_3473",
    x: -4,
    y: 0,
    width: 28,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_3473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_52_3473",
    result: "effect2_dropShadow_52_3473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_52_3473",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_3473",
    x1: 19.7122,
    y1: 0.829267,
    x2: -1.25365,
    y2: 2.79418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2269C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50684,
    stopColor: "#4573AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2269C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordicon1);
export default __webpack_public_path__ + "static/media/passwordicon(1).4a9985c27ec27bbf2f8f46a7edd301e2.svg";
export { ForwardRef as ReactComponent };